interface Partner {
  name: string;
  logo: string;
}

export const partners: Partner[] = [
  {
    name: 'HEXCEL COMPOSITES',
    logo: 'https://cdn.worldvectorlogo.com/logos/hexcel-1.svg'
  },
  {
    name: 'Fedene',
    logo: 'https://fedene.fr/wp-content/uploads/2023/12/fedene-sncu-logo-couleur-rgb.svg'
  },
  {
    name: 'Engie',
    logo: 'https://upload.wikimedia.org/wikipedia/fr/c/c6/Engie.svg'
  },
  {
    name: 'Schneider Electric',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Schneider_Electric_2007.svg'
  },
  {
    name: 'Limagrain',
    logo: 'https://mineralagro.by/02%20%D0%9B%D0%BE%D0%B3%D0%BE%D1%82%D0%B8%D0%BF%D1%8B/01-logo_red_O.svg'
  }
];